import { render, staticRenderFns } from "./elem-cascader.vue?vue&type=template&id=1aac33ae&"
import script from "./elem-cascader.vue?vue&type=script&lang=js&"
export * from "./elem-cascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports